<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-card-title>
            <div class="display-3">
              Правила программы
            </div>
          </v-card-title>
          <!--          <v-card-subtitle>{{ campaign.campaign ? campaign.description : "" }}</v-card-subtitle>-->
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="rules"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              @click:row="getRow"
            >
              <template v-slot:item.actions="{ item }">
                <task-menu
                  @delete="deleteItem(item)"
                  @edit="editItem(item)"
                />
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.statusHuman="{ item }">
                <v-chip
                  :color="getColorStatus(item.status)"
                  dark
                >
                  {{ item.statusHuman }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row dense>
              <v-col
                cols="12"
                class="d-flex justify-center flex-wrap"
              >
                <v-tooltip
                  v-if="campaign.campaignId > 0"
                  bottom
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      color="primary"
                      v-bind="attrs"
                      @click="createItem"
                      v-on="on"
                    >
                      <v-icon
                        large
                        class="ml-3"
                      >
                        mdi-plus-circle-outline
                      </v-icon>
                      <span class="md-1 mx-3">Новое правило</span>
                    </v-btn>
                  </template>
                  <span>Создать новое правило</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RuleModel from "../../models/rule.model"
import TaskMenu from "../../shared/components/task-menu/TaskMenu"
import { CampaignModel } from "../../models/campaign.model"
import WebApi from "../../shared/modules/web_api"

export default {
  name: "RuleList",
  components: { TaskMenu },
  props: {
    campaignId: {
      type: Number,
      default: 0
    },
    role: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    campaign: {},
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    headers: [
      {
        text: "Действия",
        value: "actions",
        sortable: false
      },
      {
        text: "Наименование",
        value: "name"
      },
      {
        text: "Тип начисления",
        value: "chargeTypeHuman"
      },
      // {
      //   text: "Вид начисления",
      //   value: "accrualTypeHuman"
      // },
      {
        text: "Операция",
        value: "operationHuman"
      },
      {
        text: "Размер начисления",
        value: "accrualAmountHuman"
      },
      {
      text: "Период начисления",
      value: "bonusAccrualPeriod"
},
      {
        text: "Срок действия",
        value: "bonusCancellationPeriod"
      },
      {
        text: "Статус",
        value: "statusHuman"
      },
    ],
    rules: [],
    webApi: null,
    user: null
  }),
  beforeMount () {
    // console.clear()
    this.webApi = new WebApi(this.$store)
        .deleteSuccess("Правило удалено!")
        .deleteError("Произошла ошибка при удалении Правила!")
    // this.role = +this.$route.params.role
    this.user = this.role === 1 ? 'admin' : 'client'
    this.getItems()
  },
  mounted () {},
  methods: {
    createItem () {
      this.$router.push(`/${this.user}/rule/edit/campaign/rule/${this.campaign.campaignId}/0`)
      // this.$router.push({ name: "RuleEditLink", params: { campaign: this.campaign.campaignId, rule: "0" } })
      // this.$store.dispatch("rule_store/updateRule", RuleModel.clearItems())
    },
    deleteItem (item) {
      console.log(item)
      const that = this
      this.webApi
          .delete(`${process.env.VUE_APP_LOYALTY_URL}rule/` + item.ruleId)
          .then(function (data) {
            console.log(data)
            if (data) {
              that.$store.dispatch(
                  "rule_store/updateRule",
                  RuleModel.clearItems()
              )
              that.getItems()
            }
          })
          .catch(function (error) {
            console.error(error)
          })
    },
    editItem (item) {
      console.log(item)
      // this.$store.dispatch("rule_store/updateRule", item)
      this.$router.push(`/${this.user}/rule/edit/campaign/rule/${this.campaign.campaignId}/${item.ruleId}`)
      // this.$router.push({ name: "RuleEditLink", params: { campaign: this.campaign.campaignId, rule: item.ruleId } })
    },
    getColorStatus (status) {
      return status ? "green" : "default"
    },
    getConditions (item) {
      const ruleId = item.ruleId
      console.log("ruleId=" + ruleId + " " + item.ruleId)
      // this.$store.dispatch("rule_store/updateRule", item)
      this.$router.push(`/${this.user}/condition/list/${this.role}/${item.ruleId}`)
    },
    getItems () {
      const that = this
      // this.campaign = this.$store.getters["campaign_store/getCampaign"]
      // if (this.campaign.campaign == null) {
      //   this.campaign.campaign = CampaignModel.clearItems()
      //   console.log(this.campaign.campaign)
      //   return
      // }
      // console.log("campaign=" + JSON.stringify(this.campaign))
      // console.log(this.campaign.campaign["campaignId"])
      // const campaignId = this.$route.params.campaign
      console.log("campaignId", this.campaignId)
      this.webApi
          .get(
              `${process.env.VUE_APP_LOYALTY_URL}rules/${this.campaignId}`
              // this.campaign.campaignId
          )
          .then(data => {
            data.map(m => console.log(m))
            that.rules = data.map(item => that.setItems(item))

            this.webApi
                .get(`${process.env.VUE_APP_LOYALTY_URL}api/campaign/${this.campaignId}`)
                .then(data => {
                  this.campaign = Reflect.construct(CampaignModel, [data])
                })
          })
    },
    getRow (rule) {
      console.log('getRow rule', rule)
      this.$emit('rule', rule)
    },
    setItems (data) {
      return Reflect.construct(RuleModel, [data])
    }
  }
}
</script>

<style scoped></style>
